// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import VueKindEditor from 'vue-kindeditor'
import moment from 'moment'
import 'kindeditor/kindeditor-all.js'
import 'kindeditor/lang/zh-TW.js'
import 'kindeditor/lang/en.js'
import '@/components/kindeditor/autoheight.js'
import 'kindeditor/themes/default/default.css'
import './components/my_rich_text/image.js'
import './components/my_rich_text/media.js'
import './components/my_rich_text/align.js'
import mixin from './mixin'
import './css/animation.scss'
import './directives/directives.js'
import filters from './filters/filters'
import loopRefreshToken from './base/refreshToken'
import {
  getCookie,
} from '@/base/cookie'

// 多语言
import i18n from './language';

loopRefreshToken()

Vue.mixin(mixin)

import enLang from 'element-ui/lib/locale/lang/en'
import zhTWLang from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'

const web_language_wm = getCookie('web_language_wm')
if (web_language_wm == 'en') {
  locale.use(enLang)
} else if (web_language_wm == 'tc') {
  locale.use(zhTWLang)
}

import {
  Checkbox,
  Button,
  Select,
  Input,
  InputNumber,
  Switch,
  Radio,
  Tabs,
  Icon,
  Dialog,
  Table,
  TabPane,
  Loading,
  Option,
  Alert,
  ColorPicker,
  Message,
  Notification,
  RadioGroup,
  RadioButton,
  Pagination,
  Upload,
  Slider,
  Col,
  Row,
  Tooltip,
  MessageBox,
  TableColumn,
  Collapse,
  CollapseItem,
  CheckboxGroup,
  Popover,
  Breadcrumb,
  BreadcrumbItem,
  Tree,
  Progress,
  Form,
  FormItem,
  DatePicker,
  Scrollbar,
  Tag,
  OptionGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  MenuItem,
  Divider,
  Image,
  Empty,
  Card,
  Cascader,
  InfiniteScroll,
  ButtonGroup
} from 'element-ui';
Vue.use(InfiniteScroll);
Vue.use(Card);
Vue.use(Cascader);
Vue.use(DatePicker)
Vue.use(Select);
Vue.use(Upload);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(TabPane);
Vue.use(Loading);
Vue.use(Option);
Vue.use(Alert);
Vue.use(ColorPicker);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Pagination);
Vue.use(Slider);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tooltip);
Vue.use(Switch);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(CheckboxGroup);
Vue.use(Popover);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Tree);
Vue.use(Progress);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Scrollbar);
Vue.use(Tag);
Vue.use(OptionGroup);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Divider);
Vue.use(VueKindEditor)
Vue.use(Image)
Vue.use(Empty)
Vue.use(ButtonGroup)
//插件引入
//jquery-ui中引入了jq，然后这里直接引入jq-ui就行
import $ from './base/jquery-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper';


import Templet from './base/row_jcp';
import Row_lolo from './base/row_lolo';
//import Jtemplet from './base/row_jcp';
//css引入
// import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/font-awesome.min.css'
//import './css/response.css';
// import animate from 'animate.css';
import './css/index.scss';
import './css/form.css';
import './css/fonts.css';
import './css/mb_font_size.css';
import './css/webtitle_font_size.css';
import main_dialog from '@/view/main_dialog';
import my_color_picker from '@/components/my_color_picker';
import my_radio from '@/components/my_radio';
import my_input from '@/components/my_input';
import my_select from '@/components/my_select';
import my_slider from '@/components/my_slider';
import 'swiper/dist/css/swiper.css'
import my_color from '@/components/my_color';
import my_checkbox from '@/components/my_checkbox';
import my_line_style from '@/components/my_line_style';
import my_text_biu from '@/components/my_text_biu';
import my_text_align from '@/components/my_text_align';
import my_line_height from '@/components/my_line_height';
import my_border from '@/components/my_border';
import my_font_size from '@/components/my_font_size';
import my_background from '@/components/my_background';
import my_img_button from '@/components/my_img_button';
import my_margin from '@/components/my_margin';
import my_img_cover from '@/components/my_img_cover';
import my_font_style from '@/components/my_font_style';
import my_div_edit from '@/components/my_div_edit';
import my_logo_set from '@/components/my_logo_set';
import my_link_set from '@/components/my_link_set';
import my_add_img from '@/components/my_add_img';
import my_split_line from '@/components/my_split_line';
import my_pattern_style from '@/components/my_pattern_style';
import my_search_select from '@/components/my_search_select';
import my_input_number from '@/components/my_input_number';
import my_img_pos from '@/components/my_img_pos';
import my_icon_select from '@/components/my_icon_select';
import my_collapse from '@/components/my_collapse/my_collapse'
import my_collapse_item from '@/components/my_collapse/my_collapse_item'
import my_animation from '@/components/my_animation/my_animation'
import my_module_animation from '@/components/my_animation/my_module_animation'
import my_image_animation from '@/components/my_animation/my_image_animation'
import my_comb_animation from '@/components/my_animation/my_comb_animation'
import my_banner_animation from '@/components/my_animation/my_banner_animation'
import my_page_edit from '@/components/my_page/my_page_edit'
import my_page_index from '@/components/my_page/my_page_index'
import set_link from "@/components/set_link";
import my_title from "@/components/my_title/Index"
import my_link from "@/components/my_link"
import my_add_keyWords from '@/components/my_add_keyWords';
import my_edit_btn from '@/components/my_edit_btn';
import add_button from '@/components/add_button';
import my_link_btn from '@/components/my_link_btn';
import my_close_btn from '@/components/my_close_btn';
import basic_addAtlas from '@/components/basic_addAtlas';
import my_textarea from '@/components/my_textarea'
import my_img from '@/components/my_img'
import my_rich_text from '@/components/my_rich_text'
import my_rich_text_style from '@/components/my_rich_text_style'
import my_rich_dialog from '@/components/my_rich_text/my_rich_dialog'
import my_module_style from './components/my_module_style'
import my_checkbox_box from './components/my_checkbox_box'
import my_sort from './components/my_sort'
import basic_addProduct from '@/components/basic_addProduct'
import kind_editor from './components/my_rich_text/kind_editor'
import my_public_index from '@/components/my_public_index'
import my_share from '@/components/my_share/index'
import my_share_render from '@/components/my_share/render'
import my_mb_empty_tips from '@/components/my_mb_empty_tips'
import my_moduleShow_btn from '@/components/my_moduleShow_btn'
import my_input_int_number from '@/components/my_input_int_number'
import my_button_set from '@/components/my_button_set'
import my_text_rich from '@/components/my_text_rich/kind_editor'
import my_box_shadow from '@/components/my_box_shadow'
import my_simple_box_shadow from '@/components/my_simple_box_shadow'
import my_inline_split_line from '@/components/my_inline_split_line'
import staticTips from '@/components/staticTips'
import hoverTips from '@/components/hoverTips'
import page_design from '@/components/page_design';

import './permission'
import Global from '@/base/global'
import basic_navbar from '@/widgets/basic_navbar/index';
import basic_picture from '@/widgets/basic_picture/index';
import basic_webtitle from '@/widgets/basic_webtitle/index';
import basic_vip_header from '@/widgets/basic_vip_header/index';
import basic_text from '@/widgets/basic_text/index';
import basic_button from '@/widgets/basic_button/index';
import basic_copyright from '@/widgets/basic_copyright/index';
import basic_map from '@/widgets/basic_map/index';
import basic_embed_page from '@/widgets/basic_embed_page';
import basic_searchs from '@/widgets/basic_searchs/index';
import basic_banner from '@/widgets/basic_banner/index';
import basic_searchs_results from '@/widgets/basic_searchs_results/index';
import basic_download from '@/widgets/basic_download/index';
import basic_video from '@/widgets/basic_video/index';
import basic_list_photos from '@/widgets/basic_list_photos/index';
import basic_rich_text from '@/widgets/basic_rich_text/index';
import basic_nleavemessage from '@/widgets/basic_nleavemessage/index';
import basic_atlas_catalog from '@/widgets/basic_atlas_catalog/index';
import basic_product_classification from '@/widgets/basic_product_classification/index'
import basic_article_classification from '@/widgets/basic_article_classification/index'
import basic_article from './widgets/basic_article_list/components/basic_article';
import basic_article_list from '@/widgets/basic_article_list/index'
import basic_article_info from '@/widgets/basic_article_info/index'
import basic_product_display from '@/widgets/basic_product_display/index'
import basic_product_detail from '@/widgets/basic_product_detail/index'
import basic_text_rich_type from '@/widgets/basic_text_rich_type/index'
import basic_vip_footer from '@/widgets/basic_vip_footer/index'
import basic_language from '@/widgets/basic_language/index';
import basic_footnav from '@/widgets/basic_footnav/index';
import basic_classification from '@/widgets/basic_classification/index';
import basic_zhlanguage from '@/widgets/basic_zhlanguage/index';

import '@/css/loading.css';
import 'font-awesome/css/font-awesome.min.css'
import '@/base/loading.js';
import my_title_combination from "@/components/my_title_combination"
import my_title_index from "@/components/my_title_index"
import my_percentage_slider from "@/components/my_percentage_slider"
import my_hover_btn from "@/components/my_hover_btn"
import my_add_button from '@/components/my_add_button'
import basic_plugin_code from '@/widgets/basic_plugin_code'
import vueAppend from 'vue-append'
import basic_addArticle from '@/components/basic_addArticle'
import basic_addType from '@/components/basic_addType'
import basic_deleteType from '@/components/basic_deleteType'
import basic_management from '@/components/basic_management'
import basic_h1 from '@/widgets/basic_h1'
import basic_crumbs from '@/widgets/basic_crumbs'
import my_show_num from '@/components/my_show_num'

import basic_notice from '@/widgets/basic_notice/index';
import basic_icon_combination from '@/widgets/basic_icon_combination/index';
import basic_job from '@/widgets/basic_job/index';
import basic_picture_text_swiper from '@/widgets/basic_picture_text_swiper/index';
import basic_row_tab from '@/widgets/basic_row_tab/index';
import basic_member_register from '@/widgets/basic_member_register/index';
import basic_member_center from '@/widgets/basic_member_center/index';

import basic_magic_number from '@/widgets/basic_magic_number/index'// 动态数字
import basic_progress from '@/widgets/basic_progress/index' // 进度条
import basic_video_display from '@/widgets/basic_video_display/index'
import basic_download_display from '@/widgets/basic_download_display/index'
import basic_flod_text from '@/widgets/basic_flod_text/index' // 折叠文本组件
import basic_development_history from '@/widgets/basic_development_history/index';
import basic_video_detail from "@/widgets/basic_video_detail/index" // 视频详情
import basic_floating_frame from "@/widgets/basic_floating_frame/index" // 浮框

import basic_login from "@/widgets/basic_login/index" // 登录
import basic_loginregister from "@/widgets/basic_loginregister/index" // 登录注册 头部组件
import basic_retrieve_password from '@/widgets/basic_retrieve_password/index';
import basic_recommend_list from '@/widgets/basic_recommend_list/index'; // 热门推荐
import basic_flod_text_list from '@/widgets/basic_flod_text_list/index' // 折叠文本组件
import * as utils from '@/utils/utils'
import './css/language.css';

Vue.use(vueAppend)
// Vue.use(animate);
Vue.use(VueAwesomeSwiper);


Vue.prototype.Global = new Global(Vue)
Object.defineProperty(Vue.prototype, '$message', {
  value: Message
});
Object.defineProperty(Vue.prototype, '$confirm', {
  value: MessageBox.confirm
});
Object.defineProperty(Vue.prototype, '$moment', {
  value: moment
})
Object.defineProperty(Vue.prototype, '$utils', {
  value: utils
})

Vue.component('main_dialog', main_dialog);
Vue.component('my_color_picker', my_color_picker);
Vue.component('my_radio', my_radio);
Vue.component('my_input', my_input);
Vue.component('my_select', my_select);
Vue.component('my_slider', my_slider);
Vue.component('my_color', my_color);
Vue.component('my_checkbox', my_checkbox);
Vue.component('my_line_style', my_line_style);
Vue.component('my_text_biu', my_text_biu);
Vue.component('my_text_align', my_text_align);
Vue.component('my_line_height', my_line_height);
Vue.component('my_border', my_border);
Vue.component('my_font_size', my_font_size);
Vue.component('my_background', my_background);
Vue.component('my_img_button', my_img_button);
Vue.component('my_margin', my_margin);
Vue.component('my_img_cover', my_img_cover);
Vue.component('my_font_style', my_font_style);
Vue.component('my_div_edit', my_div_edit);
Vue.component('my_logo_set', my_logo_set);
Vue.component('basic_navbar', basic_navbar);
Vue.component('basic_picture', basic_picture);
Vue.component('basic_webtitle', basic_webtitle);
Vue.component('basic_vip_header', basic_vip_header);
Vue.component('basic_text', basic_text);
Vue.component('basic_searchs', basic_searchs);
Vue.component('basic_button', basic_button);
Vue.component('basic_copyright', basic_copyright);
Vue.component('basic_map', basic_map);
Vue.component('basic_embed_page', basic_embed_page);
Vue.component('basic_download', basic_download);
Vue.component('my_link_set', my_link_set);
Vue.component('my_add_img', my_add_img);
Vue.component('my_split_line', my_split_line);
Vue.component('my_pattern_style', my_pattern_style);
Vue.component('my_search_select', my_search_select);
Vue.component('my_input_number', my_input_number);
Vue.component('my_img_pos', my_img_pos);
Vue.component('my_icon_select', my_icon_select);
Vue.component('my_collapse', my_collapse);
Vue.component('my_collapse_item', my_collapse_item);
Vue.component('my_animation', my_animation)
Vue.component('my_module_animation', my_module_animation)
Vue.component('my_image_animation', my_image_animation)
Vue.component('my_comb_animation', my_comb_animation)
Vue.component('my_banner_animation', my_banner_animation)
Vue.component('my_page_edit', my_page_edit)
Vue.component('my_page_index', my_page_index)
Vue.component('set_link', set_link);
Vue.component('my_title', my_title);
Vue.component('basic_banner', basic_banner);
Vue.component('my_link', my_link);
Vue.component('my_add_keyWords', my_add_keyWords);
Vue.component('my_title_combination', my_title_combination);
Vue.component('my_title_index', my_title_index);
Vue.component('basic_video', basic_video);
Vue.component('basic_searchs_results', basic_searchs_results);
Vue.component('my_edit_btn', my_edit_btn);
Vue.component('add_button', add_button);
Vue.component('my_link_btn', my_link_btn);
Vue.component('my_close_btn', my_close_btn);
Vue.component('basic_addAtlas', basic_addAtlas);
Vue.component('basic_list_photos', basic_list_photos);
Vue.component('basic_rich_text', basic_rich_text);
Vue.component('my_textarea', my_textarea)
Vue.component('my_img', my_img)
Vue.component('my_rich_text', my_rich_text)
Vue.component('my_rich_text_style', my_rich_text_style)
Vue.component('my_rich_dialog', my_rich_dialog)
Vue.component('basic_nleavemessage', basic_nleavemessage);
Vue.component('basic_atlas_catalog', basic_atlas_catalog);
Vue.component('basic_article_list', basic_article_list)
Vue.component('basic_article_info', basic_article_info)
Vue.component('basic_article', basic_article)
Vue.component('my_percentage_slider', my_percentage_slider);
Vue.component('my_hover_btn', my_hover_btn);
Vue.component('my_add_button', my_add_button)
Vue.component('my_module_style', my_module_style)
Vue.component('my_checkbox_box', my_checkbox_box)
Vue.component('basic_addProduct', basic_addProduct)
Vue.component('kind_editor', kind_editor)
Vue.component('basic_product_classification', basic_product_classification)
Vue.component('basic_article_classification', basic_article_classification)
Vue.component('my_public_index', my_public_index)
Vue.component('basic_product_display', basic_product_display)
Vue.component('basic_product_detail', basic_product_detail)
Vue.component('basic_text_rich_type', basic_text_rich_type)
Vue.component('basic_plugin_code', basic_plugin_code)
Vue.component('my_sort', my_sort)
Vue.component('basic_addArticle', basic_addArticle)
Vue.component('basic_addType', basic_addType)
Vue.component('basic_deleteType', basic_deleteType)
Vue.component('basic_management', basic_management)
Vue.component('my_share', my_share)
Vue.component('my_share_render', my_share_render)
Vue.component('my_mb_empty_tips', my_mb_empty_tips)
Vue.component('my_moduleShow_btn', my_moduleShow_btn)
Vue.component('my_input_int_number', my_input_int_number)
Vue.component('basic_h1', basic_h1)
Vue.component('basic_crumbs', basic_crumbs)
Vue.component('my_button_set', my_button_set)
Vue.component('my_text_rich', my_text_rich)
Vue.component('my_box_shadow', my_box_shadow)
Vue.component('my_simple_box_shadow', my_simple_box_shadow)
Vue.component('my_inline_split_line', my_inline_split_line)
Vue.component('staticTips', staticTips)
Vue.component('hoverTips', hoverTips)
Vue.component('page_design', page_design);
Vue.component('basic_vip_footer', basic_vip_footer)
Vue.component('basic_vip_header', basic_vip_header)
Vue.component('my_show_num', my_show_num)
Vue.component('basic_notice', basic_notice)
Vue.component('basic_icon_combination', basic_icon_combination)
Vue.component('basic_job', basic_job)
Vue.component('basic_picture_text_swiper', basic_picture_text_swiper)
Vue.component('basic_row_tab', basic_row_tab)
Vue.component('basic_member_register', basic_member_register)
Vue.component('basic_member_center', basic_member_center)
Vue.component('basic_language', basic_language)
Vue.component('basic_footnav', basic_footnav)
Vue.component('basic_classification', basic_classification)

Vue.component('basic_magic_number', basic_magic_number)
Vue.component('basic_progress', basic_progress)
Vue.component('basic_video_display', basic_video_display)
Vue.component('basic_download_display', basic_download_display)
Vue.component('basic_flod_text', basic_flod_text) // 折叠文本组件
Vue.component('basic_development_history', basic_development_history)
Vue.component("basic_video_detail", basic_video_detail) // 视频详情
Vue.component("basic_zhlanguage", basic_zhlanguage)
Vue.component("basic_floating_frame", basic_floating_frame) // 浮框
Vue.component("basic_login", basic_login) // 登录
Vue.component("basic_loginregister", basic_loginregister) // 登录注册头部
Vue.component("basic_retrieve_password", basic_retrieve_password)
Vue.component("basic_recommend_list", basic_recommend_list);// 热门推荐
Vue.component('basic_flod_text_list', basic_flod_text_list) // 折叠文本组件


import Video from 'video.js'
import video_zhCN from 'video.js/dist/lang/zh-CN.json'
import 'video.js/dist/video-js.css'

Video.addLanguage('zh-CN', video_zhCN);
Vue.prototype.$video = Video

import components from 'site_resource_store_assembly'
//全局注册插件
Vue.use(components.resource_store)
//引入插件的css
import 'site_resource_store_assembly/lib/site_resource_store_assembly.css';

//引入新的资源库
// 引入文件中心
import ydylFileCenter from 'ydyl-file-center'
import 'ydyl-file-center/lib/ydyl-file-center.css'
Vue.use(ydylFileCenter)
Vue.config.productionTip = false
Vue.prototype.templet = new Row_lolo(Vue);

//新版富文本组件
import richText from "site_rich_text";
import "site_rich_text/lib/site_rich_text.css";
Vue.use(richText);

const globalClickArr = []
Vue.prototype.globalClick = callback => { // 全局点击事件
  globalClickArr.push(callback)
  document.getElementById('app').onclick = e => {
    globalClickArr.forEach(data => {
      data(e, globalClickArr)
    })
  }
}

const globalScrollArr = []
Vue.prototype.globalScroll = callback => { // 全局滚动事件
  globalScrollArr.push(callback)
  // document.onscroll = e => {
  //   globalScrollArr.forEach(data => {
  //     data(e)
  //   })
  // }
  $(document).scroll(function (e) {
    globalScrollArr.forEach(data => {
      data(e)
    })
  })
}

const globalMobileScrollArr = []
Vue.prototype.globalMobileScroll = callback => { // 全局手机模式滚动事件
  globalMobileScrollArr.push(callback)
  document.querySelector('.mb_body_view').onscroll = e => {
    globalMobileScrollArr.forEach(data => {
      data(e)
    })
  }
}

const globalKeydownArr = []
Vue.prototype.globalKeydown = callback => { // 全局按键事件
  globalKeydownArr.push(callback)
  document.onkeydown = e => {
    globalKeydownArr.forEach(data => {
      data(e)
    })
  }
}

const globalResizeArr = []
let recordWidth = document.body.clientWidth
Vue.prototype.globalResizeWidth = callback => { // 全局窗口宽度大小变化事件
  globalResizeArr.push(callback)
  window.onresize = e => {
    if (recordWidth !== document.body.clientWidth) {
      recordWidth = document.body.clientWidth
      globalResizeArr.forEach(data => {
        data(e)
      })
    }
  }
}

// window.addEventListener('beforeunload', function (event) {
//   let noConfirmWhenHasUnsavedChange = Boolean(localStorage.getItem('noConfirmWhenHasUnsavedChange'))
//   if (store.state.app.is_change && !noConfirmWhenHasUnsavedChange) {
//     event.preventDefault();
//     event.returnValue = ''
//     return "您的修改尚未保存，确定要离开吗？";
//   }
// })

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

window.$ = $

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js